import { render, staticRenderFns } from "./UpdateEvent.vue?vue&type=template&id=d0ef1b24"
import script from "./UpdateEvent.vue?vue&type=script&lang=js"
export * from "./UpdateEvent.vue?vue&type=script&lang=js"
import style0 from "./UpdateEvent.vue?vue&type=style&index=0&id=d0ef1b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports